import Select from "react-select";
import { CustomSwitch } from "../../../svg/UtilsIcons";

const TOGGLE_POSITION_OPTIONS = [
  { value: "top-left", label: "Top left" },
  { value: "top-center", label: "Top center" },
  { value: "top-right", label: "Top right" },
  { value: "bottom-left", label: "Bottom left" },
  { value: "bottom-center", label: "Bottom center" },
  { value: "bottom-right", label: "Bottom right" },
];

const CameraStreamSettings = ({ edit, setEdit }) => {
  const updateProps = (patch) =>
    setEdit((prev) => ({
      ...prev,
      props: {
        ...prev.props,
        ...patch,
      },
    }));

  const url = edit?.props?.url ?? "";
  const showPowerToggle = edit?.props?.showPowerToggle !== false;
  const powerTogglePosition = edit?.props?.powerTogglePosition || "bottom-right";

  return (
    <div className="edit-content-part" style={{ flex: 0.65 }}>
      <div className="form-item">
        <label className="form-lbl" style={{ color: "var(--header-color)" }}>
          Stream URL
        </label>
        <input
          type="url"
          inputMode="url"
          className="add-column"
          placeholder="https://example.com/live/camera.m3u8"
          value={url}
          onChange={(event) => updateProps({ url: event.target.value })}
          onBlur={(event) => updateProps({ url: event.target.value.trim() })}
        />
        <small style={{ color: "var(--cell-color)", opacity: 0.75 }}>
          Use the HLS (.m3u8) stream configured for this camera.
        </small>
      </div>

      <div className="form-item automation-row">
        <div>
          <label className="form-lbl" style={{ color: "var(--header-color)" }}>
            Show on/off toggle
          </label>
          <small style={{ display: "block", color: "var(--cell-color)", opacity: 0.75 }}>
            The toggle starts or stops this widget only. It does not control the camera device.
          </small>
        </div>
        <CustomSwitch
          checked={showPowerToggle}
          onChange={(checked) => updateProps({ showPowerToggle: Boolean(checked) })}
        />
      </div>

      {showPowerToggle && (
        <div className="form-item">
          <label className="form-lbl" style={{ color: "var(--header-color)" }}>
            Toggle position
          </label>
          <Select
            classNamePrefix="react-select"
            options={TOGGLE_POSITION_OPTIONS}
            value={TOGGLE_POSITION_OPTIONS.find((option) => option.value === powerTogglePosition)}
            onChange={(option) => updateProps({ powerTogglePosition: option?.value || "bottom-right" })}
            isClearable={false}
          />
          <small style={{ color: "var(--cell-color)", opacity: 0.75 }}>
            The control uses its own strip outside the video, so it never covers the camera view.
          </small>
        </div>
      )}
    </div>
  );
};

export default CameraStreamSettings;
